import React from 'react'
import './MarqueeComp.css'

const MarqueeComp = () => {
  return (
    <marquee className="marquee-ind"> *** No New Notifictions *** </marquee>
  )
}

export default MarqueeComp